// extracted by mini-css-extract-plugin
module.exports = {"Index":"completion_Index__1I6cS"};